export class UserPhone {
  public userPhoneId: number;
  public userId: number;
  public label: string;
  public number: string;
  public default: boolean;
  public actived: boolean;
}
